(function (d) {
	"use strict";
	var widgetScript = d.createElement('script');
	widgetScript.id = 'unistats-widget-script';
	widgetScript.src = '//widget.unistats.ac.uk/js/unistats.widget.js';
	var scriptTags = d.getElementsByTagName('script')[0];
	if (d.getElementById('unistats-widget-script')) { return; }
	scriptTags.parentNode.insertBefore(widgetScript, scriptTags);
} (document));

$(document).ready(function(){

	careerCoach();
	imgToBg();
	//mobileImgToBg();
	//addHasDropClass();
	addDropdownOpenClass();
	appendPointerElementToDropdown();
	setDropdownPointerPosition();
	initSearchForm();
	initMobileMenu();
	initShortListDropdown();
	//removeShortListItem();
	playVideo();
	setRightOffsetOfInfoSectionContent();
	initStorySlideshow();
	initBannersSlideshow();
	initCS();
	secondaryNav();
	initCarouselMobile();
	initStatisticCarousel();
	//initCounterUp();
	initInfoSlideshow();
	initSocialCarousel();
	initSocialBox();
	initEqualHeight();
	initPopupYouTubeBox();
	initSlideshow();
	initStaffSlideshow();
	initTestimialsSlideshow();
	setRightOffsetOfContentArea();
	setAccordionPanelActiveClass();
	initFullScreenGallery();
	initAccordionWithViewAllLink();
	initCarousel();
  initNewsCarousel();
	initAppear();
	//initLoadMoreItems();
	initCheckBox();
	limitCheckBox();
	showAllTerms();
	pannelumViewer();
	accordionScroll();

	$('.course-box .block h3').matchHeight();

  if(jQuery('.fl-builder-edit').length === 0 && jQuery('#cookiePopup').length) {
    var $this = jQuery('#cookiePopup'),
        cname = $this.data('name');

    $('.modal-dialog').parent().on('show.bs.modal', function(e){
      $(e.target).appendTo('body'); 
    });

    checkCookiePopup($this, cname);

    $this.on('hidden.bs.modal', function () {
      setCookie(cname, guid(), 14);
    });

    $this.find('.btn').on('click', function () {
      setCookie(cname, guid(), 14);
    });
  }

	$('.fl-builder-content').on('fl-builder.layout-rendered fl-builder.preview-rendered', function() {

		careerCoach();
		imgToBg();
		//mobileImgToBg();
		//addHasDropClass();
		addDropdownOpenClass();
		appendPointerElementToDropdown();
		setDropdownPointerPosition();
		initSearchForm();
		initMobileMenu();
		initShortListDropdown();
		//removeShortListItem();
		playVideo();
		setRightOffsetOfInfoSectionContent();
		initStorySlideshow();
		initBannersSlideshow();
		initCS();
		secondaryNav();
		initCarouselMobile();
		initStatisticCarousel();
		//initCounterUp();
		initInfoSlideshow();
		initSocialCarousel();
		initSocialBox();
		initEqualHeight();
		initPopupYouTubeBox();
		initSlideshow();
		initTestimialsSlideshow();
		initStaffSlideshow();
		setRightOffsetOfContentArea();
		setAccordionPanelActiveClass();
		initFullScreenGallery();
		initAccordionWithViewAllLink();
		initCarousel();
    initNewsCarousel();
		initAppear();
		//initLoadMoreItems();
		initCheckBox();
		limitCheckBox();
		showAllTerms();
		pannelumViewer();
		accordionScroll();
	});

});
$(window).load(function() {
	$(window).scrollTop(0);
	jQuery('html').scrollTop(0);
	limitCheckBox();
});
$(window).unload(function() {
	jQuery('html').scrollTop(0);
	$(window).scrollTop(0);
});
$(document).ready(function(){
    jQuery('html').scrollTop(0);
});
$(window).resize(function(){

	setDropdownPointerPosition();

	setRightOffsetOfInfoSectionContent();

	setRightOffsetOfContentArea();
	imgToBg();

	setTimeout(function() {
		initEqualHeight();
	}, 500);

});
function commaSeparateNumber(n) {
    var parts=n.toString().split(".");
    return parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}
/* function commaSeparateNumber(val) {
	if(val.length){
		while (/(\d+)(\d{3})/.test(val.toString())) {
			val = val.toString().replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
		}
		return val;
	}

} */

function accordionScroll(){
	$('.accordion .panel-title a.collapsed').on('click', function(){
		let tabScroll = $(this).parent();
		setTimeout(function(){
			$('html, body').animate({
				scrollTop: tabScroll.offset().top - 80
			}, 1000);
		}, 500);


	});
}
function careerCoach(){
	jQuery('ul.careers-list > li > a').on('click',function(e){
		//e.preventDefault();
		var $this = $(this);
		var career_link = $this.attr("href");
		var career_data = $this.data('occupation-info');
		var formatNumber = new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumSignificantDigits: 6 });

		$('#single-career-link').attr("href",career_link);
		if(typeof career_data != 'undefined'){
			$('#career-total-careers').text(career_data.opp_per_year);
			$('#career-potential-earnings').attr('data-count', Math.ceil(career_data.earnings.potential)).text('0');
			$('#career-average-earnings').attr('data-count', Math.ceil(career_data.earnings.average)).text('0');
			$('#career-entry-earnings').attr('data-count', Math.ceil(career_data.earnings.entry)).text('0');
			var elements = ['career-potential-earnings', 'career-average-earnings', 'career-entry-earnings'];
			$.each( elements, function(k, v) {

				var $this = elements[k],
					countTo = $('#'+ $this +'').attr('data-count'),
					currency = $('#'+ $this +'').attr('data-currency'),
					element = $('#'+ $this +'');

					if(typeof currency == "undefined"){
						currency = '';
					}
					element.prop('Counter',0).animate({
						Counter: countTo
					}, {
						duration: 3500,
						easing: 'swing',
						step: function (now) {
							var num = Math.ceil(now).toString();
							if(Number(num) > 999){
								while (/(\d+)(\d{3})/.test(num)) {
									num = num.replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
								}
							}
							element.text(currency + num);
							//console.log('step');
						},
						complete: function() {
							element.text(new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumSignificantDigits: 6 }).format(Math.ceil(countTo)));
						//alert('finished');
						}
					});
			});
			return false;
		}

	});
}

function pannelumViewer() {
	// your page initialization code here
	// the DOM will be available here
	var elements = $('.panorama-viewer');

	for (let i = 0; i < elements.length; ++i) {
		var element = elements[i];
		if( element.id.length > 0){
			var	elementId = element.id;
		}else {
			var	elementId = $('.'+ element.className +'').attr('data-id');
		}

		var elementImg = $('#'+ elementId +'').attr('data-image');
			/* console.log(elementId);
			console.log(elementImg); */
		pannellum.viewer(elementId, {
			"type": "equirectangular",
			"panorama": ""+elementImg+"",
			"autoLoad": true
		});
	}

 };
function limitCheckBox(){
	var limit = 3;
	var checkbox = $('input.shortlist-course-item');
	//var checkedcount = 0;
	checkbox.on('click', function(evt) {
		if ($('input.shortlist-course-item:checked').length > limit) {
			this.checked = false;
		}
		if ($('input.shortlist-course-item:checked').length >= 1) {
			$('.short-list-widget .btn-apply').fadeIn('normal');
		}else {
			$('.short-list-widget .btn-apply').fadeOut('normal');
		}
		applyToCourses();
    });
};
function applyToCourses(){
	var applyBtn = document.getElementById('apply-to-courses');
	var choices = [];
	var els = document.getElementsByName('shortlist-course[]');

	for (var i=0;i<els.length;i++){
	  if ( els[i].checked ) {
	    choices.push(els[i].value);
	  }
	}

	var url = "https://join.boston.ac.uk/?ReturnUrl=%2fPage%2fCreateAppPersonalDetails%3fUIOIds_InList%3d"+choices.toString()+"&UIOIds_InList="+choices.toString();
	applyBtn.setAttribute('href',url);
}
function showAllTerms(){
	$('.view-all-terms').on('click',function(e){
		e.preventDefault();
		var $item_selector = '.item-selector-'+$(this).data('item-selector');
		$($item_selector).removeClass('hidden');
		$(this).remove();
	});
}
function playVideo(){
	var elementVideo = $(".bg-video video");
	if(elementVideo.length){
		elementVideo.get(0).play();
	}
}

function imgToBg() {
  $('.visual-area .img, .video-box, .visual-section .img, .bg-image, .info-item .img, .story-widget .img, .banner-image, .video-block .img, .team-box .img, .image-widget .img > span, .post-box .img > span, .social-box .photo > a, .location-box .photo-box .photo, .info-block .image, .news-list .img, .images-list .img > span').each(function () {
    var $element = $(this);

    var $mobileEl = $(this).attr('data-mobile-img');
    var $tabletEl = $(this).attr('data-tablet-img');
    var $desktopEl = $(this).find('> img').attr('src');

    if (typeof ($desktopEl) === 'undefined') {
      $desktopEl = $(this).attr('data-desktop-img');
    }

    if ($desktopEl) {
      if ($desktopEl.length > 0) {
        $element.css('background-image', 'url(' + $desktopEl + ')');
      }
    }

    if ($(window).width() < 480 && typeof ($mobileEl) !== 'undefined') {
      if ($mobileEl.length) {
        $element.css('background-image', 'url(' + $mobileEl + ')');
        return;
      }
    }

    if ($(window).width() < 992 && typeof ($tabletEl) !== 'undefined') {
      if ($tabletEl.length) {
        $element.css('background-image', 'url(' + $tabletEl + ')');
        return;
      }
    }
  });
}

/* function mobileImgToBg() {
	$('.visual-area .img,').each(function() {

		if ($mobileEl.length > 0) {
			$(this).css('background-image', 'url(' + $mobileEl + ')');
		}
	});
} */
function addHasDropClass() {
	$('.main-menu li').has('> .mega-dropdown').addClass('has-drop');
}

function addDropdownOpenClass() {
	$('.main-menu > ul > li.has-drop').each(function(){
		var this_ = $(this);
		var megaMenu = $(this).children('.mega-dropdown');
		var otherMegaMenu = $('li.has-drop > .mega-dropdown');
		var topBarMenu = $('.top-links a');
		this_.hover(
			function (){
				$('body').addClass('dropdown-open');
				megaMenu.addClass('opened');
				$(otherMegaMenu).not($(megaMenu)).removeClass('opened');
			},
			function(){
				$('body').removeClass('dropdown-open');
				setTimeout(function() {
					megaMenu.removeClass('opened');
				}, 1000)
			}
		);
		topBarMenu.hover(
			function(){
				megaMenu.removeClass('opened');
			}
		);
	});
}

function appendPointerElementToDropdown() {
	$('<span class="pointer"></span>').appendTo('.main-menu .mega-dropdown');
}

function setDropdownPointerPosition() {
	$('.mega-dropdown').each(function() {
		var this_ = $(this),
		liOffset = this_.closest('li').offset().left;
		this_.find('.pointer').css({
			'left': liOffset + (this_.closest('li').outerWidth() / 2 - $('.pointer').width() / 2)
		});
	});
}

function initSearchForm() {
	$('.search-box .search-opener').click(function(){
		$('body').addClass('search-opened');
		$(this).closest('.search-box').find('input[type="search"]').focus();
		return false;
	});
}

function initMobileMenu() {
	var $menu = $('.main-menu').clone();
	$menu.find('.mega-dropdown').remove();
	$menu.attr( "id", "mobile-menu" ).removeClass('main-menu');
	$menu.mmenu({
		navbar: {
			titleLink: "anchor"
		},
		offCanvas: {
			position: "right",
			zposition: "front",
			menuInjectMethod:'append',
			menuWrapperSelector:'#wrapper'
		},
		keyboardNavigation: {
			enable: true,
			enhance: true,
		},
	});
	$('#header .btn-menu').clone().addClass('visible-xs-block').appendTo('.mm-menu');
	var mmenuAPI = $menu.data('mmenu'),
		mobileNav = $('#mobile-menu');
	$('.btn-menu').click(function(){
		if ($('html').hasClass('mm-opened')) {
			mmenuAPI.close();
		} else{
			closeShortListDropdown();
			mmenuAPI.open();
		};
		return false;
	});
	$('.mm-menu .mm-navbar .mm-prev').text('Back');
	$('.mm-listview .mm-next').wrapInner('<span></span>');
	$('#header .top-links').clone().appendTo('.mm-menu .mm-panel:nth-child(1)');
	$('.search-box form#filters').first().clone(true).appendTo('.mm-menu .mm-panel:nth-child(1)');
	$('#header .logo').clone().addClass('visible-xs-block').appendTo('.mm-menu .mm-panel:nth-child(1)');
}

function initShortListDropdown() {
	$('.short-list-box .btn-short-list').click(function(){
		$(this).closest('.short-list-box').toggleClass('opened');
		$(this).closest('.short-list-box').find('.short-list-dropdown').fadeToggle(300);
		return false;
	});
	$('.short-list-box .short-list-dropdown .btn-close').click(function(){
		$(this).closest('.short-list-box').find('.short-list-dropdown').fadeToggle(300);
		return false;
	});
}

function closeShortListDropdown() {
	$('.short-list-box').removeClass('opened');
	$('.short-list-box').find('.short-list-dropdown').fadeOut(300);
	return false;
}

function removeShortListItem() {
	$('.short-list .link-remove').click(function(){
		$(this).closest('li').hide();
		return false;
	});
}

function setRightOffsetOfInfoSectionContent() {
	$('.info-section').not('.find-path').each(function(){
		var $this = $(this),
			$screenWidth = $(window).width(),
			$containerWidth = $this.find('.container').width(),
			$sideSpace = ($screenWidth - $containerWidth) / 2;
		$this.find('.info-widgets').css('margin-right', '-' + $sideSpace + 'px');
	});
}

function initStorySlideshow() {
	$('.story-slideshow').slick({
		dots: false,
		arrows: true,
		infinite: true,
		fade: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true
	});
}
function initTestimialsSlideshow() {
	$('.testimonials-slideshow').slick({
		dots: false,
		arrows: true,
		infinite: true,
		fade: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 6000

	});
}

function initBannersSlideshow() {
	$('.banners-slideshow').slick({
		dots: true,
		arrows: true,
		infinite: false,
		fade: true,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 7000,
		responsive: [{
			breakpoint: 768,
			settings: {
				arrows: false
			}
		}]
	});
  $('.home-banner').slick({
    dots: true,
    arrows: true,
    infinite: false,
    fade: true,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 10000,
    responsive: [{
      breakpoint: 768,
      settings: {
        arrows: false
      }
    }]
  })
  .on('beforeChange', function(event, slick, currentSlide, nextSlide){
    setTimeout(function () {
      var data = {"event":"command","func":"pauseVideo","args":""};
      var message = JSON.stringify(data);
      if (undefined !== $("iframe", slick.$slides[currentSlide])[0]) {
        $("iframe", slick.$slides[currentSlide])[0].contentWindow.postMessage(message, '*');
      }
    }, 2000);
  })
  .on('afterChange', function(event, slick, currentSlide, nextSlide){
    //If we're on the first slide hide the Previous button and show the Next
    if (currentSlide === 0) {
      $('.home-banner .slick-prev').hide();
      $('.home-banner .slick-next').show();
    } else {
      $('.home-banner .slick-prev').show();
    }

    //If we're on the last slide hide the Next button.
    if (slick.slideCount === currentSlide + 1) {
      $('.home-banner .slick-next').hide();
    }
    setTimeout(function () {
      var data = {"event":"command","func":"playVideo","args":""};
      var message = JSON.stringify(data);
      if (undefined !== $("iframe", slick.$slides[currentSlide])[0]) {
        $("iframe", slick.$slides[currentSlide])[0].contentWindow.postMessage(message, '*');
      }
    }, 2000);
  });
}
function initStatisticCarousel() {
	$('.statistic-carousel').slick({
		dots: false,
		arrows: false,
		infinite: false,
		fade: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: false,
		responsive: [
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 3
				}
			},
			{
				breakpoint: 768,
				settings: {
					slidesToShow: 1,
					variableWidth: true,
					centerMode: true,
					centerPadding: 0,
					initialSlide: 1
				}
			}
		]
	});
}

function initInfoSlideshow() {
	$('.info-slideshow:not(.slick-initialized)').slick({
		dots: true,
		arrows: false,
		infinite: true,
		fade: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 6000,
    draggable: false,
    swipe: false,
    responsive: [
      {
        breakpoint: 641,
        settings: {
          draggable: false,
          swipe:false,
        }
      }, {
        breakpoint: 441,
        settings: {
          draggable: false,
          swipe:false,
        }
      }
    ]
	});
}

function initSocialCarousel() {
	$('.social-carousel').slick({
		dots: true,
		arrows: true,
		infinite: false,
		fade: false,
		slidesToShow: 4,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 6000,
		responsive: [
			{
				breakpoint: 1240,
				settings: {
					slidesToShow: 3,
					slidesToScroll: 3
				}
			},
			{
				breakpoint: 768,
				settings: {
					arrows: true,
					slidesToShow: 1,
					slidesToScroll: 1,
					variableWidth: true,
					centerMode: true,
					centerPadding: 0,
					initialSlide: 1
				}
			}
		]
	});
}
function initSocialBox() {
	$('.social-box').has('.photo').addClass('has-photo');
}

function initCS() {
	var isMobile = $(window).width() > 767 ? false : true ;
	$('.cs-1').selectpicker({
		style: '',
		width: '100%',
		hideDisabled: true,
		mobile: isMobile,
		template: {
			caret: '<i class="fa fa-angle-down"></i>'
		}
	});
}
function secondaryNav() {
	$(".secondary-nav ul li").has("ul").addClass("has-drop").append('<i class="opener"></i>');
	$('.secondary-nav li').each(function(){
		if($(this).hasClass('current_page_ancestor')) {
			$(this).find('> ul').slideDown(0);
		}
	});
	$('.secondary-nav li').each(function(){
		if($(this).hasClass('current_page_item')) {
			$(this).addClass('open');
			$(this).find('> ul').slideDown(0);
		}
	});
	$('.secondary-nav .opener').click(function(e){
		e.preventDefault();
		$(this).siblings('ul').slideToggle().closest('li').toggleClass('open').siblings('li:not(.current_page_ancestor)').removeClass('open');
		$(this).closest('li').siblings('li:not(.current_page_ancestor)').children('ul').slideUp();
	});
}
function initCarouselMobile() {
	if ($(window).width() <= 767 && !$('.carousel-mobile').hasClass('slick-initialized')) {
		$('.carousel-mobile').slick({
			arrows: false,
			dots: true,
			slide: '.slide',
			infinite: false
		});
	};
	$(window).resize(function() {
		if ($(window).width() <= 767 && !$('.carousel-mobile').hasClass('slick-initialized')) {
			$('.carousel-mobile').slick({
				arrows: false,
				dots: true,
				slide: '.slide',
				infinite: false
			});
		} else if($(window).width() >= 768 && $('.carousel-mobile').hasClass('slick-initialized')){
			$('.carousel-mobile').slick('unslick').removeClass('slick-initialized');
		};
	});
}

function initEqualHeight() {
	$('.courses-list .course-box .block').matchHeight();
	$('.courses-list .course-box .course-features').matchHeight();
	$('.courses-list .course-box').matchHeight();
	$('.social-box').matchHeight();
	$('.career-section .person-box, .career-section .careers-box').matchHeight();
	var heightCareersBox = $('.career-section .careers-box .careers-box__text-left').height();
	$('.careers-box .careers-list').css('height', heightCareersBox);
	$('.search-area').not('.find-a-course').find('.search-items .search-item').matchHeight();
	$('.info-slideshow .image-widget figcaption').matchHeight();
	$('.latest-news .footer-content').matchHeight();
	$('.latest-news .footer-content .news-list__title').matchHeight();
	/* $('.team-block figcaption').matchHeight();
	$('.news-list .team-box figure').matchHeight();
	$('.news-list li .news-list__title').matchHeight();
	$('.news-list li .news-list__excerpt').matchHeight().css('margin-bottom', '17px'); */
}

function initPopupYouTubeBox() {
	$('.popup-youtube').magnificPopup({
		type: 'iframe',
			iframe: {
				markup: '<div class="mfp-iframe-scaler">'+
							'<div class="mfp-close"></div>'+
							'<iframe class="mfp-iframe" frameborder="0" allow="autoplay" allowfullscreen></iframe>'+
						'</div>',
				patterns: {
				youtube: {
					index: 'youtube.com/',
					id: 'v=',
          src: 'https://www.youtube.com/embed/%id%?autoplay=1'
        }
		},
			srcAction: 'iframe_src',
		}
	});
}

function initSlideshow() {
	$('.slideshow').slick({
		fade: true,
		slide: '.slide',
		autoplay: true
	});
}

function initStaffSlideshow() {
	var staffSlideshow = $('.staff-slideshow:not(.slick-initialized)').slick({
		dots: false,
		arrows: true,
		infinite: true,
		fade: false,
		slidesToShow: 1,
		slidesToScroll: 1,
		autoplay: true,
		autoplaySpeed: 6000,
		responsive: [
			{
				breakpoint: 768,
				settings: {
					arrows: true,
					variableWidth: true,
					centerMode: false,
					centerPadding: 0
				}
			}
		]
	});
  staffSlideshow.on('beforeChange', function () {
    var $current = $(this).find('.slick-current iframe');
    $current.attr('src', $current.attr('src'));
  });
}

function setRightOffsetOfContentArea() {
	$('.content-area').each(function(){
		var $this = $(this),
			$screenWidth = $(window).width(),
			$containerWidth = $this.find('.container').width(),
			$sideSpace = ($screenWidth - $containerWidth) / 2;
		$this.find('.content-holder').css('margin-right', '-' + $sideSpace + 'px');
	});
}

function setAccordionPanelActiveClass() {
	$('.accordion .collapse.in').closest('.panel').addClass('active');
	$('.accordion').on('show.bs.collapse', function(e) {
		$(e.target).closest('.panel').addClass('active');
	})
	.on('hide.bs.collapse', function(e) {
		$(e.target).closest('.panel').removeClass('active');
	});
}

function initFullScreenGallery() {
	$('.full-screen-gallery').magnificPopup({
		delegate: '.widget-link',
		type: 'image',
		gallery:{
			enabled: true
		}
	});
}

function initAccordionWithViewAllLink() {
	$('.accordion .panel-title ').has('.view-all-box').addClass('has-view-all-link');
}

function initCarousel() {
	$('.carousel').slick({
		slidesToShow: 3,
		slidesToScroll: 1,
		responsive: [
			{
				breakpoint: 1240,
				settings: {
					slidesToShow: 2
				}
			},
			{
				breakpoint: 992,
				settings: {
					slidesToShow: 1
				}
			}
		]
	});
}

function initNewsCarousel() {
  $('.news-carousel').slick({
    slidesToShow: 3,
    slidesToScroll: 1,
    dots: true,
    arrows: true,
    infinite: true,
    responsive: [
      {
        breakpoint: 1240,
        settings: {
          slidesToShow: 2
        }
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 1
        }
      },
    ]
  });
}

function initAppear() {
	appear({
		elements: function elements(){
			return document.getElementsByClassName('appear');
		},
		appear: function appear(el){
			var item = $(el);
			item.addClass('active');
			item.find('.statistic-box .value , .earn-box').each(function() {
				item.find('.statistic-box-value, .val').each(function () {
					var $this = $(this),
						countTo = $this.attr('data-count'),
						currency = $this.attr('data-currency');

						if(typeof currency == "undefined"){
							currency = '';
						}

						$(this).prop('Counter',0).animate({
							Counter: countTo
						}, {
							duration: 2500,
							easing: 'swing',
							step: function (now) {
								var num = Math.ceil(now).toString();
								if(Number(num) > 999){
									while (/(\d+)(\d{3})/.test(num)) {
										num = num.replace(/(\d+)(\d{3})/, '$1' + ',' + '$2');
									}
								}
								$(this).text(currency + num);
							},
							complete: function() {
                if(currency.length) {
                  $this.text(new Intl.NumberFormat('en-GB', { style: 'currency', currency: 'GBP', maximumSignificantDigits: 6 }).format(Math.ceil(countTo)));
                }
							//alert('finished');
								$this.stop();
							}
						});
				});
				//$(this).dynamicNumber('start');
			});
		},
		bounds: 0,
		reappear: true
	});

}

function loadCourses(count_){
	for (var i=0; i<count_; i++){
		$('.load-courses-list, .load-full-time-courses-list, .load-more-part-time-courses-list, .load-more-apprenticeship-courses-list').append($('<li></li>').load('ajax/courses-content.html', function(){
			$(this).css('opacity','0').fadeTo(600, 1);
		}));
	}
}

function initLoadMoreItems() {
	var loadCoursesCount = 8;
	$('.load-more-js, .load-more-full-time-js, .load-more-part-time-js, .load-more-apprenticeship-js').click(function(){
		loadCourses(loadCoursesCount);
		return false;
	});
}

function initCheckBox() {
	$('.check-box').each(function() {
		$(this).append('<label for="' + $(this).find('input').attr('id') + '">&nbsp;</label>');
	});
}

/* $(document).on('mouseup touchend ', function (e){
	var container = $('#header .search-box');
	if (!container.is(e.target) && container.has(e.target).length === 0){
		$('body').removeClass('search-opened');
	}
}); */

document.addEventListener('DOMContentLoaded', function() {
	var supportsMixBlendMode = window.getComputedStyle(document.body).mixBlendMode;
	if(typeof supportsMixBlendMode == 'undefined') {
		$('body').addClass('not-support-mix-blend-mode');
	}
}, false);

function setCookie(cname, cvalue, exdays) {
  var d = new Date();
  d.setTime(d.getTime() + (exdays * 24 * 60 * 60 * 1000));
  var expires = 'expires=' + d.toGMTString();
  document.cookie = cname + '=' + cvalue + '; ' + expires;
}

function getCookie(cname) {
  var name = cname + '=';
  var ca = document.cookie.split(';');
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) == ' ') c = c.substring(1);
    if (c.indexOf(name) == 0) {
      return c.substring(name.length, c.length);
    }
  }
  return '';
}

function checkCookiePopup($this, cname) {
  var popup = getCookie(cname);
  if (popup == '' || popup == null) {
    $this.modal('show');
  }
}

function guid() {
  function p8(s) {
    var p = (Math.random().toString(16) + '000000000').substr(2, 8);
    return s ? '-' + p.substr(0, 4) + '-' + p.substr(4, 4) : p;
  }
  return p8() + p8(true) + p8(true) + p8();
}



// WEBPACK FOOTER //
// ./scripts/cutup/scripts.js